import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useRef as o, useState as f } from "react";
import { useEvent as a } from './use-event.js';

function T(l, r, c) {
  var _f = f(c),
      _f2 = _slicedToArray(_f, 2),
      i = _f2[0],
      s = _f2[1],
      e = l !== void 0,
      t = o(e),
      u = o(!1),
      d = o(!1);

  return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [e ? l : i, a(function (n) {
    return e || s(n), r == null ? void 0 : r(n);
  })];
}

export { T as useControllable };